// @ts-nocheck
import React, { useState, useEffect } from 'react';
import { Modal, Box, Button, Typography, TextField } from '@mui/material';
import { styled } from '@mui/material/styles';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import axios from 'axios';
import { RUTA_API_ALIAS } from '../../../../Contantes/Constantes';
import { setupInterceptorsTo } from '../../../../Componentes/API/AxiosBuilder';
import { useBody } from '../../../../Body/state/BodyContext';

const Root = styled('div')(({ theme }) => ({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#fff',
    boxShadow: 24,
    padding: '25px',
    width: 420,
    borderRadius: 8,
    [theme.breakpoints.down('sm')]: {
        width: '85%',
    },
}));

export function EditarNombreAliasModal({ open, onClose, aliasMail, aliasNombreInicial, aliasData, onSuccess }) {
    const axiosInstance = setupInterceptorsTo(axios.create());
    const { setSuccess, setMessage } = useBody();
    const [nombre, setNombre] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (open) setNombre(aliasNombreInicial ?? '');
    }, [open, aliasNombreInicial]);

    const handleGuardar = async () => {
        if (!nombre.trim()) return;
        setLoading(true);
        try {
            const area = typeof aliasData.area === 'object' ? aliasData.area?.id : aliasData.area;
            const payload = {
                area,
                descripcion: aliasData.descripcion,
                destinatarios: aliasData.destinatarios,
                mail: aliasData.mail,
                nombre,
                visibilidadLibreta: parseInt(aliasData.visibilidadLibreta),
                mailOriginal: aliasData.mail,
            };
            await axiosInstance.put(RUTA_API_ALIAS, payload);
            setSuccess("Nombre del alias actualizado.");
            onSuccess(nombre);
            onClose();
        } catch (error) {
            const msg = error.response?.data?.error ?? "No se pudo actualizar el nombre del alias.";
            setMessage(msg);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal open={open} onClose={onClose}>
            <Root>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <DriveFileRenameOutlineIcon color="primary" />
                        <Typography variant="h6">Editar nombre del alias</Typography>
                    </Box>

                    <TextField
                        label="Email del alias"
                        value={aliasMail ?? ''}
                        disabled
                        fullWidth
                        variant="outlined"
                    />

                    <TextField
                        label="Nombre del Alias"
                        value={nombre}
                        onChange={(e) => setNombre(e.target.value)}
                        onKeyPress={(e) => e.key === 'Enter' && handleGuardar()}
                        fullWidth
                        variant="outlined"
                        autoFocus
                    />

                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                        <Button sx={{ textTransform: 'none' }} variant="outlined" onClick={onClose} disabled={loading}>
                            Cancelar
                        </Button>
                        <Button
                            sx={{ textTransform: 'none' }}
                            variant="contained"
                            color="primary"
                            disabled={loading || !nombre.trim()}
                            onClick={handleGuardar}
                        >
                            {loading ? 'Guardando...' : 'Guardar'}
                        </Button>
                    </Box>
                </Box>
            </Root>
        </Modal>
    );
}
